const CloseTradeEnum = Object.freeze({
    ACCEPT : 'accept',
    REJECT: 'reject'
})

export default CloseTradeEnum;